module.exports = __webpack_public_path__ + "img/Columbia.b7b3181a.png";